import StyledDatepicker from "./StyledDatepicker";  

export default StyledDatepicker;
